import { render, staticRenderFns } from "./ImportPersons.vue?vue&type=template&id=21204be4&"
import script from "./ImportPersons.vue?vue&type=script&lang=js&"
export * from "./ImportPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports